import { render, staticRenderFns } from "./NodataDetails.vue?vue&type=template&id=716a493b&scoped=true"
import script from "./NodataDetails.vue?vue&type=script&lang=js"
export * from "./NodataDetails.vue?vue&type=script&lang=js"
import style0 from "./NodataDetails.vue?vue&type=style&index=0&id=716a493b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716a493b",
  null
  
)

export default component.exports